import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from "./base.sevice";

@Injectable()
export class NotificationService extends BaseService {

    url = `${environment.apiBaseUrl}/consumers/notifications`;

    constructor(private http: HttpClient) {
        super();
    }

    get() {
        return this.http.get(`${this.url}?ping=true`);
    }
}